<template>
  <div>
    <v-card-text v-if="type_view == 'tab'" :style="` width: 100%; height: ${height}px; overflow: auto`" class="pa-0" ref="scrollContainer">
      <div class="chat py-3" ref="chat_block">
        <portal-target name="content" />
      </div>
    </v-card-text>
    <v-dialog v-if="type_view == 'full'" v-model="dialog" fullscreen hide-overlay scrollable>
      <v-card tile>
        <v-toolbar flat dark color="primary" max-height="64">
          <v-toolbar-title>{{ leadName }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text :style="` width: 100%; height:auto; overflow: auto`" class="pa-2 mt-1" ref="scrollContainer">
          <div class="chat py-3" ref="chat_block">
            <portal-target name="content" />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <portal to="content">
      <div v-for="(group, key) in grouped" :key="key" class="mb-6">
        <!-- Заголовок блока -->
        <v-card class="pa-3 mb-2" color="primary" dark1 flat>
          <div class="text-h6">Этап: <a-view-selectapi :value="group.status" :model="{ api: 'mechti/leads_status/select' }" /></div>

          <!-- Карточки задач -->
          <div>
            <v-card class="amo-card pa-4" outlined>
              <div v-for="(item, i) in group.items" :key="item.id_" :ref="`task-${item.id}`">
                <component
                  v-if="getElement(item)"
                  :key="item.id"
                  :is="getElement(item)"
                  :status="group.status"
                  :data="item"
                  :task="leadTasks"
                  @result="onResult(item, $event)"
                  @call-info="showCallInfo"
                />
                <hr v-if="i < group.length - 1" class="mb-1 mt-1" />
              </div>
            </v-card>
          </div>
        </v-card>
      </div>
    </portal>
    <lead-callinfo v-model="callInfoDialog" :data="{ analysisResult, callInfoType }" :analysisResult="analysisResult" :type="callInfoType" />
    <s-edit-form-async ref="editField" />
  </div>
</template>

<script>
import "./../components";
import leads from "@/mixins/leads";
import { getAccess, modelOptions, genModel } from "@/components/mixings";
export default {
  mixins: [getAccess, modelOptions, leads, genModel],
  components: {},
  props: {
    view: { type: String, default: "tab" },
    leadData: { type: Object, default: () => {} },
    height: { type: Number, default: 300 },
  },
  data() {
    return {
      type_view: null,
      loaded: false,
      dialog: false,
      m_lead: this.$store.getters["config/get"].models.leads,
      m_task: this.$store.getters["config/get"].models.leads.tasks,
      m_task_template: this.$store.getters["config/get"].models.dir_leadsGroup.leads_task_template,
      m_action: this.$store.getters["config/get"].models.leads.actions,
      tasks: [],
      actions: [],
      result: [],
      grouped: {},
      activeTask: null,
      tasks_: null,
      lead_: null,
      users: {},
      analysisResult: {},
      callInfoDialog: false,
      callInfoType: 0,
    };
  },
  watch: {
    dialog(v) {
      if (!v) {
        this.$emit("close");
        this.type_view = this.view;
      }
      this.scrollTo();
    },
    type_view(v) {
      console.log("v");
      if (v == "full") {
        this.dialog = true;
      }
    },
    callInfoDialog(v) {
      if (!v) this.analysisResult = {};
    },
  },
  created() {
    console.log("created live");
    this.initData();
    this.type_view = this.view;
  },
  computed: {
    leadName() {
      return this.lead?.name;
    },
    lead() {
      if (!this.lead_) this.getLeadData(this.leadData?.id);
      return this.lead_;
    },
    leadTasks() {
      if (!this.tasks_) this.makeTasks({ leads_status_group_id: this.lead.type });
      //console.log("leadTasks", this.tasks_);
      return this.tasks_;
      // this.makeTasks({ leads_status_group_id: this.data.type });
    },
    status() {
      return this.lead?.status;
    },
  },
  methods: {
    async makeTasks(f) {
      if (!this.tasks_) this.tasks_ = await this.getTasks(f);
    },
    async getLeadData(id) {
      if (this.leadData.name) this.lead_ = this.leadData;
      if (!this.lead_) {
        this.lead_ = await this.getLead(id);
      }
    },
    setView(v) {
      this.type_view = v;
    },
    async callForm(e) {
      return this.$refs.editField.show(e);
    },

    getElement(item) {
      // console.log("get item ", item.type_);
      if (!item?.type_) return false;
      return "lead-" + item.type_;
    },

    waitForEvent(eventName, payload) {
      return new Promise((resolve) => {
        this.$emit(eventName, payload, resolve);
      });
    },

    async onSetForm(e) {
      const { data, name, title, task_id } = e;
      const id = this.lead.id;
      if (!id) return;
      if (name.includes("data.")) {
        let r = await this.$axios.get(this.m_lead.api + "/" + id);
        if (r.data.status == "ok" && r.data?.data?.id == id) {
        } else return false;
        let lead = r.data.data;
        if (!lead.data) lead["data"] = {};
        this.$set(lead.data, name.split(".")[1], data);
        let d = { id: lead.id, data: lead.data };
        let response = await this.$axios.post(this.m_lead.api, d);
        if (response.data.data) {
          this.$emit("setData", { data: response.data.data.data });
          this.$root.$emit("show-info", {
            text: "Форма сохранена",
          });
          this.$axios.post("/mechti/leads_action", { lead_id: id, comment: "Заполнена форма: " + title, data: { task_id } });
          return response.data;
        }
      }
      return false;
    },
    async onResult(item, e) {
      //console.log({ item, e });
      const checkFillForm = async (e) => {
        for (let i = 0; i < e.forms.length; i++) {
          let model = this.m_lead.form.find((m) => m.name == "data." + e.forms[i]);
          let form;
          if (typeof model.model == "string") form = this.getFromConfig("models." + model.model);
          else form = Object.assign({}, model.model);
          let res = await this.callForm({ title: form.title, model: form.form });
          if (res) {
            const setFormResult = await this.onSetForm({
              name: model.name,
              data: res,
              title: model.title,
              task_id: item.id,
            });
            //console.log("setFormResult", setFormResult);
            if (setFormResult?.status !== "ok") {
              throw "Ошибка сохранения. " + (setFormResult?.message || "[НЕИЗВЕСТНАЯ]");
            }
          } else throw "Не заполнена форма. Действие отменено";
        }
      };
      if (e.action == "createTask") {
        try {
          if ((e?.forms || []).length) {
            for (let i = 0; i < e.forms.length; i++) {
              let model = this.m_lead.form.find((m) => m.name == "data." + e.forms[i]);
              let form;
              if (typeof model.model == "string") form = this.getFromConfig("models." + model.model);
              else form = Object.assign({}, model.model);
              let res = await this.callForm({ title: form.title, model: form.form });
              if (res) {
                //  const setFormResult = await this.waitForEvent("setForm", {
                const setFormResult = await this.onSetForm({
                  name: model.name,
                  data: res,
                  title: model.title,
                  task_id: item.id,
                });
                //console.log("setFormResult", setFormResult);
                if (setFormResult?.status !== "ok") {
                  throw "Ошибка сохранения. " + (setFormResult?.message || "[НЕИЗВЕСТНАЯ]");
                }
              } else throw "Не заполнена форма. Действие отменено";
            }
          }
          let mf = [];
          if ((e?.actionFields || []).length) {
            let m = this.m_action.form.filter((m) => e.actionFields.includes(m.name)).map((f) => ({ ...f, name: `action__${f.name}` }));
            if (m.length) mf = [...mf, { name: "label_a", type: "label", value: "Данные выполненного действия" }, ...m];
          }
          if ((e?.taskFields || []).length) {
            let m = this.m_task.form.filter((m) => e.taskFields.includes(m.name)).map((f) => ({ ...f, name: `task__${f.name}` }));
            if (m.length) mf = [...mf, { name: "label_t", type: "label", value: "Данные новой задачи" }, ...m];
          }
          let c_data = {};
          if (mf.length) {
            let res = await this.$refs.editField.show({
              title: "Укажите необходимые данные",
              data: {},
              model: mf,
              btn: { ok: "ОК" },
            });
            if (res) {
              c_data = Object.assign({}, res);
            } else throw "Вы не заполнили данные. Действие отменено";
          }
          const lead_group = await this.getLeadGroup(this.lead.type);
          const task_id = e.task_id;
          let tasks_data;
          let users = {};
          if (task_id) {
            const task = task_id ? await this.getTaskTemplate(task_id) : null;

            const task_eventon = c_data?.task__eventon
              ? c_data.task__eventon
              : task?.data?.task_duration
              ? new Date(Date.now() + task.data.task_duration * 60000)
              : new Date().local;
            if (!lead_group.data?.supervisor) throw `Не могу определить РОП воронки`;
            if (!lead_group.data?.lawyer) throw `Не могу определить юриста воронки`;
            let u = await this.getUsers([this.lead.user_id, lead_group.data?.lawyer, lead_group.data?.supervisor]);
            users.broker = { id: this.lead.user_id, name: u.find((e) => e.id == this.lead.user_id)?.name };
            users.lawyer = { id: lead_group.data?.lawyer, name: u.find((e) => e.id == lead_group.data?.lawyer)?.name };
            users.supervisor = { id: lead_group.data?.supervisor, name: u.find((e) => e.id == lead_group.data?.supervisor)?.name };
            let user_id = !task
              ? null
              : task.data.user_type == "broker"
              ? users.broker.id
              : task.data.user_type == "lawyer"
              ? users.lawyer.id
              : task.data.user_type == "supervisor"
              ? users.supervisor.id
              : null;
            this.users = Object.assign({}, users);
            if (!user_id) {
              let t = "???";
              try {
                t = this.m_task_template.form.find((f) => f.name == "data.user_type").options.find((f) => f.value == task.data.user_type).text;
              } catch (error) {
                console.error(error);
              }
              throw `Не могу определить исполнителя задачи [${t}]`;
            }
            let notify_before_minutes = task.data?.event_before || [];
            if (!Array.isArray(notify_before_minutes)) notify_before_minutes = [notify_before_minutes];
            let create_task_data;
            if (task.data.task_outer_user) {
              let desc;
              try {
                desc = this.parseTemplate(task.data.task_description, { d: this });
              } catch (error) {
                console.error(error);
                throw `Ошибка формирования описания задачи для юриста`;
              }
              create_task_data = {
                type: "contract-client",
                name: task.name,
                description: desc,
                is_important: 40,
                date_start: new Date().local,
                date_end: task_eventon,
                status: 0,
                user_id: users?.[task.data.task_outer_user],
                watchers: [
                  [this.lead.user_id, lead_group.data?.supervisor].map((m) => {
                    return { user_id: m };
                  }),
                ],
              };
              if (!create_task_data.user_id) throw `Ошибка определения пользователя для внешней задачи`;
            }
            if (!user_id) {
              let t = "???";
              try {
                t = this.m_task_template.form.find((f) => f.name == "data.user_type").options.find((f) => f.value == "supervisor").text;
              } catch (error) {
                console.error(error);
              }
              throw `Не могу определить исполнителя задачи [${t}]`;
            }
            tasks_data = [
              {
                type: task_id,
                lead_id: item.lead_id,
                status: 1,
                leads_task_template_id: task_id,
                eventon: task_eventon,
                comment: c_data?.task__comment,
                user_id,
                data: { notify_before_minutes: task?.need_event ? notify_before_minutes.sort((a, b) => b - a) : null },
                create_task_data,
              },
            ];
          }
          let data = {
            lead_id: item.lead_id,
            type: item.leads_task_template_id,
            data: { result: `${e.action_text || e.text}`, task_id: item.id },
            comment: c_data?.action__comment,
            task_id: item.id,
            set_lead_status: e.status_id,
            tasks_data,
          };
          //console.log({ e, item, data, users });
          await this.$axios.post("/mechti/leads_action", data);
          if (data.set_lead_status) this.$emit("setData", { status: data.set_lead_status });
        } catch (error) {
          console.error(error);
          this.$root.$emit("show-info", { type: "error", text: error });
        }
      } else if (e.action == "changeGroup") {
        try {
          if ((e?.forms || []).length) {
            for (let i = 0; i < e.forms.length; i++) {
              let model = this.m_lead.form.find((m) => m.name == "data." + e.forms[i]);
              let form;
              if (typeof model.model == "string") form = this.getFromConfig("models." + model.model);
              else form = Object.assign({}, model.model);
              let res = await this.callForm({ title: form.title, model: form.form });
              if (res) {
                const setFormResult = await this.onSetForm({
                  name: model.name,
                  data: res,
                  title: model.title,
                  task_id: item.id,
                });
                //console.log("setFormResult", setFormResult);
                if (setFormResult?.status !== "ok") {
                  throw "Ошибка сохранения. " + (setFormResult?.message || "[НЕИЗВЕСТНАЯ]");
                }
              } else throw "Не заполнена форма. Действие отменено";
            }
          }
          let mf = [];
          if ((e?.actionFields || []).length) {
            let m = this.m_action.form.filter((m) => e.actionFields.includes(m.name)).map((f) => ({ ...f, name: `action__${f.name}` }));
            if (m.length) mf = [...mf, { name: "label_a", type: "label", value: "Данные выполненного действия" }, ...m];
          }
          if ((e?.taskFields || []).length) {
            let m = this.m_task.form.filter((m) => e.taskFields.includes(m.name)).map((f) => ({ ...f, name: `task__${f.name}` }));
            if (m.length) mf = [...mf, { name: "label_t", type: "label", value: "Данные новой задачи" }, ...m];
          }
          let c_data = {};
          if (mf.length) {
            let res = await this.$refs.editField.show({
              title: "Укажите необходимые данные",
              data: {},
              model: mf,
              btn: { ok: "ОК" },
            });
            if (res) {
              c_data = Object.assign({}, res);
              console.log(res);
            } else throw "Вы не заполнили данные. Действие отменено";
          }
          const group_id = e.group_id;
          const lead_group = await this.getLeadGroup(group_id);
          let data = {
            lead_id: item.lead_id,
            type: group_id,
            task_id: item.id,
            set_lead_group: lead_group.id,
            set_lead_status: lead_group.data.status_default,
            comment: c_data?.action__comment,
            data: { result: `${e.action_text || e.text}`, task_id: item.id },
          };
          if (lead_group.data.task_default) {
            const user_id = this.lead.user_id;
            const task_id = lead_group.data.task_default;
            const task = await this.getTaskTemplate(task_id);
            const task_eventon = task?.data?.task_duration ? new Date(Date.now() + task.data.task_duration * 60000) : new Date().local;
            let notify_before_minutes = task.data?.event_before || [];
            let tasks_data = [
              {
                type: task_id,
                lead_id: item.lead_id,
                status: 1,
                leads_task_template_id: lead_group.data.task_default,
                comment: c_data?.task__comment,
                eventon: task_eventon,
                user_id,
                data: { notify_before_minutes: task?.need_event ? notify_before_minutes.sort((a, b) => b - a) : null },
              },
            ];
            data = Object.assign({}, data, { tasks_data });
          }
          await this.$axios.post("/mechti/leads_action", data);
          this.$emit("refresh");
        } catch (error) {
          console.error(error);
          this.$root.$emit("show-info", { type: "error", text: error });
        }
      } else {
        this.$root.$emit("show-info", { type: "error", text: "Неизвестное действие" });
      }
      this.initData();
    },
    parseTemplate(template, context = {}) {
      // можно добавить полезные утилиты (например формат даты)
      const helpers = {
        formatDate(date, locale = "ru-RU") {
          if (!(date instanceof Date)) date = new Date(date);
          return date.toLocaleDateString(locale);
        },
        upper(s) {
          return String(s).toUpperCase();
        },
        lower(s) {
          return String(s).toLowerCase();
        },
      };

      return template.replace(/\{([^}]+)\}/g, (_, expr) => {
        try {
          // создаём безопасное окружение с помощью new Function
          const fn = new Function(...Object.keys(context), ...Object.keys(helpers), `return ${expr};`);

          return fn(...Object.values(context), ...Object.values(helpers));
        } catch (e) {
          console.warn("Ошибка в выражении:", expr, e.message);
          return `{${expr}}`; // оставляем как есть, если не удалось вычислить
        }
      });
    },

    async getUsers(ids) {
      const api = "/mechti/tasks/users/select";
      const r = await this.$axios.get(api, { params: { filters: { id: ids } } });
      return r.data.data.map((d) => Object.assign({ id: d.value, name: d.text }, d));
    },
    async scrollTo(id) {
      this.$nextTick(() => {
        id = id || this.activeTask;

        if (!id) return;

        const chatBlockRef = this.$refs.chat_block;
        const chatBlock = chatBlockRef?.$el || chatBlockRef;
        if (!chatBlock) return;

        const taskRef = this.$refs[`task-${id}`];
        const taskElement = Array.isArray(taskRef) ? taskRef[0] : taskRef;
        const el = taskElement?.$el || taskElement;
        if (!el) return;

        // убедимся, что всё нашли
        // console.log("chatBlock:", chatBlock);
        // console.log("task element:", el);
        // this.$emit("scrollTo", el.offsetTop);
        this.onScrollTo(el.offsetTop);
        return;
        chatBlock.scrollTo({
          top: el.offsetTop - 20,
          behavior: "smooth",
        });
      });
    },
    async initData() {
      //this.result = [...(this.lead?.messages || [])];
      await this.getLeadData(this.leadData?.id);
      await this.fitchData();
      await this.scrollTo();
    },
    async fitchData() {
      try {
        this.actions = null;
        this.tasks = null;
        let api = this.m_task.api;
        let params = {
          filters: { lead_id: this.lead.id },
        };
        let d = await this.$axios.get(api, { params });
        if (d.data && d.data.data) {
          this.tasks = [...d.data.data];
        }
        api = this.m_action.api;

        d = await this.$axios.get(api, { params });
        if (d.data && d.data.data) {
          this.actions = [...d.data.data];
        }
        this.makeList();
      } catch (error) {
        this.$root.$emit("show-info", { type: "error", text: "Ошибка загрузки данных" });
        console.error(error);
      }
    },
    makeList() {
      const tasks = this.tasks.filter((t) => t.status == 1).map((t) => ({ ...t, actions: [], type_: "task", id_: `t-${t.id}` }));

      const linked = [];
      const unlinked = [];

      for (const act of this.actions
        .map((a) => ({
          ...a,
          type_: "action",
          id_: `a-${a.id}`,
        }))
        .multiSort(["createdon"])) {
        const taskId = act.data?.task_id;
        if (taskId) {
          const task = tasks.find((t) => t.id === taskId);
          if (task) {
            task.actions.push(act);
            linked.push(act);
          } else {
            unlinked.push(act); // если указанный task не найден
          }
        } else {
          unlinked.push(act); // действия без связи
        }
      }

      // Теперь объединим задачи и несвязанные действия
      let merged = [
        ...tasks,
        ...unlinked.map((a) => ({
          ...a,
          type_: "action",
          id_: `a-${a.id}`,
        })),
      ];

      // Сортируем по createdon (включая и задачи, и действия)
      merged = merged.multiSort(["createdon", "type_"]);
      //console.log("merged", merged);

      this.activeTask = tasks?.[0]?.id || null;
      let grouped = this.makeGroups(merged);
      //this.$set(this, "grouped", grouped);
      this.$set(this, "grouped", grouped);

      //console.log("grouped", grouped);
    },
    makeGroups(merged) {
      const grouped = [];
      let currentGroup = null;

      for (const task of merged) {
        const status = task.lead_status || 0;

        // если первая группа или статус изменился — начинаем новую группу
        if (!currentGroup || currentGroup.status !== status) {
          currentGroup = { status, items: [] };
          grouped.push(currentGroup);
        }

        currentGroup.items.push(task);
      }
      return grouped;
    },
    onScrollTo(tt) {
      this.$nextTick(() => {
        const containerRef = this.$refs.scrollContainer;
        const container = Array.isArray(containerRef) ? containerRef[0] : containerRef;
        const el = container?.$el || container;
        if (!el) return;

        if (el) el.scrollTop = el.scrollHeight;
      });
    },
    showCallInfo(e, t) {
      this.callInfoType = t;
      this.analysisResult = e;
      this.callInfoDialog = true;
    },
  },
};
</script>
<style lang="scss">
@import "@/style/education.scss";
.chat1 {
  overflow-y: auto;
  max-height: 100vh; /* или фиксированная высота */
}
</style>
